/**
 * Machine types - must match backend MACHINE_NAME_MAP in machine_types.py
 * value = short code (used internally for metadata/filtering)
 * label = display name (shown to users in dropdowns)
 */
export const MACHINE_TYPES = [
  { value: 'pmk', label: 'PMK 300-2' },
  { value: 'mkt', label: 'MKT 80-2' },
  { value: 'drucker', label: 'Drucker' },
  { value: 'zufuehrung', label: 'Zufuehrung' },
  { value: 'waegesystem', label: 'Waegesystem' },
  { value: 'casepacker', label: 'Casepacker' },
  { value: 'palettierer', label: 'Palettierer' },
] as const;

// None option for documents that span multiple machines or are general
export const MACHINE_NONE_OPTION = {
  value: '',
  label: 'Allgemein (keine Maschine)',
} as const;

// Type for machine code values
export type MachineCode = (typeof MACHINE_TYPES)[number]['value'] | '';

/**
 * Get the display label for a machine code.
 * @param code Machine short code (e.g., 'pmk') or empty string
 * @returns Display name (e.g., 'PMK 300-2') or 'Allgemein' if empty
 */
export function getMachineLabel(code: string | undefined | null): string {
  if (!code) return MACHINE_NONE_OPTION.label;
  const machine = MACHINE_TYPES.find((m) => m.value === code);
  return machine?.label ?? code;
}

/**
 * Get display labels for multiple machine codes.
 * @param codes Array of machine short codes
 * @returns Array of display names
 */
export function getMachineLabels(codes: string[] | undefined | null): string[] {
  if (!codes || codes.length === 0) return [];
  return codes.map((code) => {
    const machine = MACHINE_TYPES.find((m) => m.value === code);
    return machine?.label ?? code;
  });
}

/**
 * Check if a code is a valid machine type.
 * @param code Machine code to validate
 * @returns True if valid machine code
 */
export function isValidMachine(code: string): boolean {
  return MACHINE_TYPES.some((m) => m.value === code);
}
